import { ErrorMessage } from "../../models/ErrorMessage.ts";

export const HandledErrorMessages: Record<number, Omit<ErrorMessage, "description">> = {
  "400": {
    code: 400,
    title: "Bad Request"
  },
  "401": {
    code: 401,
    title: "Unauthorized"
  },
  "403": {
    code: 403,
    title: "Unauthorized access"
  },
  "404": {
    code: 404,
    title: "Not Found"
  },
  "500": {
    code: 500,
    title: "Unexpected error"
  }
};
